import React from 'react';
import Header from '../../components/Header';
import Navbar from '../../components/Navbar';

export default function index() {
  return (
    <div>
      <Navbar />
      <Header type="hotels"/>
    </div>
  )
}
